import Glide, { Controls, Breakpoints, Anchors, Autoplay, Images, Keyboard, Swipe } from '@glidejs/glide/dist/glide.modular.esm';
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/util';
import 'bootstrap/js/src/tab';

// Document ready
function ready(fn)
{
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 1);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

// Doc ready handler
ready(function () {

    // Mobile menu toggle
    document.querySelector('.menu-toggle').addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelector('.header--primary--nav').classList.toggle('show');
    });

    let subMenuActions = document.querySelectorAll('.header--primary--nav li.menu-item-has-children > .sub-action');
    for (let i = 0; i < subMenuActions.length; i++) {
        subMenuActions[i].addEventListener('click', function (e) {
            subMenuActions[i].parentElement.classList.toggle('show');
        });
    }

    // Scroll to top
    document.querySelector('.to-top').addEventListener('click', function (e) {
        e.preventDefault();
        smoothScroll('#header');
    });

    let isInViewport = function (elem, percentVisible = 0) {
        let rect = elem.getBoundingClientRect();
        let windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        return !(
            Math.floor(100 - (((rect.top >= 0 ? 0 : rect.top) / +-(rect.height / 1)) * 100)) < percentVisible ||
            Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
        )
    };

    // Screen size changes to desktop
    function listenerCallback(evt)
    {
        if (evt.matches) {
            // turn off mobile menu
            document.querySelector('.header--primary--nav').classList.remove('show');
            document.querySelector('#menu-main').classList.remove('show');

            // turn off submenus
            let subMenuParents = document.querySelectorAll('.header--primary--nav .menu-item-has-children');
            for (let i = 0; i < subMenuParents.length; i++) {
                subMenuParents[i].classList.remove('show');
            }
        }
    }

    const mql = window.matchMedia("(min-width: 768px)");
    try {
        mql.addEventListener('change', listenerCallback)
    } catch (e) {
        mql.addListener(listenerCallback)
    }

    // Fade in transition
    // if (mql.matches) {
    let scrollElements = '.card-grid--item, .apj-products .btn, .wp-block-latest-posts li, ' +
        '.spotlight-instagram-feed, :not(.parallax) > .footer, :not(.parallax) > #main .apj-tabs, .wp-block-group.fade-in, ' +
        '.wp-block-group.fade-in, wp-block-media-text.fade-in';
    let scrollItems = document.querySelectorAll(scrollElements);
    if (scrollItems) {
        for (let i = 0; i < scrollItems.length; i++) {
            if (!isInViewport(scrollItems[i])) {
                scrollItems[i].classList.add('scroll-trigger');
            }
        }
    }
    // }

    // Scroll detection
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
        // if (mql.matches) {
        // Toggle header
        const currentScroll = window.pageYOffset;
        if (currentScroll <= 140) {
            document.body.classList.remove('scroll-up');
            document.body.classList.remove('scroll-down');
            return;
        }

        if (currentScroll > lastScroll && !document.body.classList.contains('scroll-down')) {
            document.body.classList.remove('scroll-up');
            document.body.classList.add('scroll-down');
        } else if (currentScroll < lastScroll && document.body.classList.contains('scroll-down')) {
            document.body.classList.remove('scroll-down');
            document.body.classList.add('scroll-up');
        }
        lastScroll = currentScroll;

        let scrollElementsX = '.card-grid--item, .apj-products li, .apj-products .btn, .wp-block-latest-posts li, ' +
            '.spotlight-instagram-feed, :not(.parallax) > .footer, ' +
            ':not(.parallax) > .apj-tabs, .wp-block-group.fade-in, .wp-block-group.fade-in, wp-block-media-text.fade-in';
        let scrollItemsX = document.querySelectorAll(scrollElementsX);
        if (scrollItemsX) {
            for (let i = 0; i < scrollItemsX.length; i++) {
                if (isInViewport(scrollItemsX[i], 5)) {
                    scrollItemsX[i].classList.remove('scroll-trigger');
                }
            }
        }
        // }
    });

    // Scroll to id
    let smoothScroll = function (identifier) {
        let element = document.querySelector(identifier)
        let topPos = element.offsetTop - 150;
        window.scroll({
            top: topPos,
            behavior: 'smooth'
        });
    };

    // Scroll to hash on load
    let hash = window.location.hash.substr(1);
    if (hash !== "") {
        smoothScroll('#' + hash);
    }

    // Scroll to hash on click
    let anchors = document.querySelectorAll('a');
    for (let i = 0; i < anchors.length; i++) {
        if (anchors[i].href.split("#")[0] === window.location.protocol + '//' + window.location.host + window.location.pathname
            && anchors[i].hash !== ""
            && anchors[i].getAttribute('role') !== 'tab'
            && anchors[i].getAttribute('role') !== 'button') {
            anchors[i].addEventListener('click', function (e) {
                e.preventDefault();
                smoothScroll(this.hash);
            });
        }
    }

    // Banner slider
    if (document.querySelector('.banner-slider.slides')) {
        const bannerEl = document.querySelector('.banner-slider.slides');
        let banner = new Glide(bannerEl, {
            type: 'carousel',
            animationDuration: 1500,
            autoplay: 4000,
            gap: 0
        });
        banner.mount({Controls, Autoplay, Keyboard, Swipe, Images, Anchors});
    }

    // Products slider
    if (document.querySelector('.apj-products--slider.slides')) {
        let products = new Glide('.apj-products--slider.slides', {
            type: 'carousel',
            animationDuration: 1200,
            autoplay: false,
            gap: 20,
            perView: 4,
            breakpoints: {
                1200: {
                    perView: 4
                },
                920: {
                    perView: 3
                },
                576: {
                    perView: 2
                },
                414: {
                    perView: 1
                }
            }
        });
        products.on('mount.after', function () {
            let productSliderItems = document.querySelectorAll('.apj-products--slider li');
            if (productSliderItems) {
                for (let i = 0; i < productSliderItems.length; i++) {
                    productSliderItems[i].classList.add('scroll-trigger');
                }
            }
        });
        products.mount({Controls, Autoplay, Keyboard, Swipe, Breakpoints, Images, Anchors});

        document.querySelector('.apj-products .glide__arrow--right').addEventListener('click', () => {
            products.go('>');
        });
        document.querySelector('.apj-products .glide__arrow--left').addEventListener('click', () => {
            products.go('<');
        });
    }

    let qv = document.querySelectorAll('.qv-button');
    for (let i = 0; i < qv.length; i++) {
        qv[i].addEventListener('click', function (e) {
            e.preventDefault();
        });
    }

    // Social share popup
    let sharePopup = function (el, intWidth, intHeight, blnResize) {
        intWidth = intWidth || '500';
        intHeight = intHeight || '400';
        var strResize = (blnResize ? 'yes' : 'no');
        var strTitle = ((typeof el.getAttribute('title') !== 'undefined') ? el.getAttribute('title') : 'Social Share'),
            strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize;
        window.open(el.href, strTitle, strParam).focus();
    };

    // Add events to social share popup
    if (document.querySelector('.post--footer .share')) {
        let social = document.querySelectorAll('.post--footer .share');
        for (let i = 0; i < social.length; i++) {
            social[i].addEventListener('click', function (e) {
                e.preventDefault();
                sharePopup(this);
            });
        }
    }
});